webpackJsonp([142629428675168],{

/***/ 376:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Glaskunst Seidelmann","description":"Glaskunst Seidelmann - mundgeblasene Glaskunst, aus eigener Herstellung bzw. handbemalt und jedes St&uuml;ck ein Unikat. Hier finden Sie eine kleine Auswahl unseres Produktspektrums."}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-ee89ff4190170b6e5219.js